<script setup lang="ts">
	import {cn} from '@/scripts/utils/utils';
	import {
		SwitchRoot,
		type SwitchRootEmits,
		type SwitchRootProps,
		SwitchThumb,
		useForwardPropsEmits,
	} from 'reka-ui';
	import {computed, type HTMLAttributes} from 'vue';

	const props = defineProps<
		SwitchRootProps & {class?: HTMLAttributes['class']}
	>();

	const emits = defineEmits<SwitchRootEmits>();

	const delegatedProps = computed(() => {
		const {class: _, ...delegated} = props;

		return delegated;
	});

	const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<SwitchRoot
		v-bind="forwarded"
		:class="
			cn(
				'peer focus-visible:ring-ring focus-visible:ring-offset-background data-[state=checked]:bg-primary data-[state=unchecked]:bg-input inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
				props.class
			)
		"
	>
		<SwitchThumb
			:class="
				cn(
					'bg-background pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5'
				)
			"
		>
			<slot name="thumb" />
		</SwitchThumb>
	</SwitchRoot>
</template>
